import { regex } from "@/constant/config";
import countryList from "@/constant/countryList";
import authApi from "@/api/auth";
import commonActionHandle from "@/commonActionHandle";
import { GPURENTAL_STATUS_CODE } from "@/constant/config";
import baseComponent from '@/scripts/baseComponent';
import VueRecaptcha from 'vue-recaptcha';
import moment from 'moment';
import countryPhoneCodes from '@/constant/countryPhoneCodes'
const homepage = process.env.VUE_APP_HOMEPAGE;
const enableRecaptcha = (process.env.VUE_APP_ENABLED_RECAPTCHA == 'true');

// console.log(countryPhoneCodes.reduce((prev, cur) => {
//     prev[cur.code] = cur.name;
//     return prev;
// }, {}))

export default {
    props: {
        location: {
            type: String,
            default: null
        },
    },
    extends: baseComponent,
    components: { VueRecaptcha },

    data() {
        var validateUserName = (rule, value, callback) => {
            if (value.match(regex.noSpecialChar)) {
                return callback();
            } else {
                return callback(new Error(this.$lang.register.validationSpecialCharUsername));
            }
        };
        var validatePhone = (rule, value, callback) => {
            if (value.match(regex.phone)) {
                return callback();
            } else {
                return callback(new Error(this.$lang.register.validationTypePhone));
            }
        };
        var validatePassword = (rule, value, callback) => {
            if (value.match(regex.password)) {
                if (!value.match(regex.passwordAtLeastUppercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastUppercaseChar));
                if (!value.match(regex.passwordAtLeastLowercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastLowercaseChar));
                if (!value.match(regex.passwordAtLeastNumber)) return callback(new Error(this.$lang.register.passwordAtLeastNumber));
                if (!value.match(regex.passwordAtLeastSpecialChar)) return callback(new Error(this.$lang.register.passwordAtLeastSpecialChar));
                if (!value.match(regex.passwordAtNoSpace)) return callback(new Error(this.$lang.register.passwordAtNoSpace));
                return callback();
            } else {
                return callback(new Error(this.$lang.register.validationTypePassword));
            }
        };
        var validateConfirmPassword = (rule, value, callback) => {
            if (value !== this.registerForm.password) {
                return callback(new Error(this.$lang.register.validationConfirmPasswordMatch));
            } else {
                if (value.match(regex.password)) {
                    if (!value.match(regex.passwordAtLeastUppercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastUppercaseChar));
                    if (!value.match(regex.passwordAtLeastLowercaseChar)) return callback(new Error(this.$lang.register.passwordAtLeastLowercaseChar));
                    if (!value.match(regex.passwordAtLeastNumber)) return callback(new Error(this.$lang.register.passwordAtLeastNumber));
                    if (!value.match(regex.passwordAtLeastSpecialChar)) return callback(new Error(this.$lang.register.passwordAtLeastSpecialChar));
                    if (!value.match(regex.passwordAtNoSpace)) return callback(new Error(this.$lang.register.passwordAtNoSpace));
                    return callback();
                } else {
                    return callback(new Error(this.$lang.register.validationTypePassword));
                }
            }
        };
        var validateIsAgreeTerm = (rule, value, callback) => {
            if (value !== true) {
                return callback(
                    new Error(this.$lang.register.validationTerms)
                );
            } else {
                return callback();
            }
        };
        return {
            homepage: homepage,
            options: Object.keys(countryList).map(item => {
                return {
                    value: item,
                    label: countryList[item],
                    image: `/static/flag/${item.toLowerCase()}.png`
                };
            }),
            test: Object.keys(countryList).map(item => {
                return {
                    value: item,
                    label: countryList[item],
                    image: `/static/flag/${countryList[item].toLowerCase()}.png`
                };
            }),
            value: "",
            isLoading: false,
            enabledRecaptcha: enableRecaptcha,
            visiblePopoverUsername: false,
            visiblePopoverPassword: false,
            phoneCodeKeyword: '',
            registerForm: {
                userName: "",
                email: "",
                region: "",
                phoneCode: "+1",
                phone: "",
                password: "",
                confirmPassword: "",
                isAgreeTerm: true,
                language: "",
                timeZone: "",
                affiliateId: "",
                nationality: "",
                browserDetails: "",
                resolutionDevice: "",
                deviceInformation: '',
                recaptchaToken: "",
                registeredHistory: "",
            },
            rules: {
                userName: [
                    {
                        required: true,
                        message: this.$lang.register.validationRequiredUsername,
                        trigger: "blur"
                    },
                    { validator: validateUserName, trigger: ["blur", "change"] },
                    {
                        min: 3,
                        message: this.$lang.register.validationMinUsername,
                        trigger: ["blur", "change"]
                    },
                    {
                        max: 20,
                        message: this.$lang.register.validationMaxUsername,
                        trigger: ["blur", "change"]
                    }
                ],

                email: [
                    {
                        required: true,
                        message: this.$lang.register.validationRequiredEmail,
                        trigger: "blur"
                    },
                    {
                        type: "email",
                        message: this.$lang.register.validationTypeEmail,
                        trigger: ["blur", "change"]
                    },
                    {
                        max: 50,
                        message: this.$lang.register.validationMaxEmail,
                        trigger: ["blur", "change"]
                    }
                ],

                phone: [
                    {
                        required: true,
                        message: this.$lang.register.validationrequiredPhone,
                        trigger: "blur"
                    },
                    { validator: validatePhone, trigger: ["blur", "change"] },
                    {
                        min: 7,
                        message: this.$lang.register.validationMinPhone,
                        trigger: ["blur", "change"]
                    },
                    {
                        max: 15,
                        message: this.$lang.register.validationMaxPhone,
                        trigger: ["blur", "change"]
                    }
                ],

                region: [
                    {
                        required: true,
                        message: this.$lang.register.validationRequiredRegion,
                        trigger: "change"
                    }
                ],

                password: [
                    {
                        required: true,
                        message: this.$lang.register.validationRequiredPassword,
                        trigger: "blur"
                    },
                    {
                        min: 6,
                        message: this.$lang.register.validationMinPassword,
                        trigger: ["blur", "change"]
                    },
                    {
                        max: 50,
                        message: this.$lang.register.validationMaxPassword,
                        trigger: ["blur", "change"]
                    },
                    { validator: validatePassword, trigger: "blur" }
                ],

                confirmPassword: [
                    {
                        required: true,
                        message: this.$lang.register.validationRequiredPassword,
                        trigger: "blur"
                    },
                    { validator: validateConfirmPassword, trigger: "blur" }
                ],
                isAgreeTerm: [{ validator: validateIsAgreeTerm, trigger: "change" }]
            }
        };
    },

    computed: {
        canExecute() {
            return (!this.enabledRecaptcha || this.registerForm.recaptchaToken !== '');
        },
        phoneCodesOptions() {
            if (!this.phoneCodeKeyword) return countryPhoneCodes;
            return countryPhoneCodes.filter(x =>
                x.name.toLowerCase().includes(this.phoneCodeKeyword.toLowerCase()) || x.dial_code.toLowerCase().includes(this.phoneCodeKeyword.toLowerCase())
            )
        }
    },
    created() {
        //add gtag
        // let gTagMngScript = document.createElement("script");
        // gTagMngScript.type = `text/javascript`;
        // gTagMngScript.text = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        // new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        // j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        // 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        // })(window,document,'script','dataLayer','G-S4B3S14MQQ');`;
        // document.head.appendChild(gTagMngScript);
        
        this.addScript(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','G-S4B3S14MQQ');`);

        this.addScript(`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','GTM-5QRTC7K');`);

        //start script
        let requestId = this.$route.query.requestId;
        let currentSource = {
            requestId: requestId ? requestId : null,
            createdAt: moment().utc(),
        }

        if (!requestId) {
            this.registerForm.nationality = 'other';
        }
        else {
            this.registerForm.nationality = this.$route.query.requestId;
        }

        let registeredHistoryLocalStore = localStorage.getItem("registered_history");
        let registeredHistory = [];
        if (registeredHistoryLocalStore) {
            registeredHistory = JSON.parse(registeredHistoryLocalStore);
            registeredHistory.push(currentSource);
        } else {
            registeredHistory = [currentSource];
        }

        this.registerForm.registeredHistory = JSON.stringify(registeredHistory);
        localStorage.setItem("registered_history", this.registerForm.registeredHistory);
        this.initRegion();
    },
    mounted() {
    },
    methods: {
        customFilter(query) {
            this.phoneCodeKeyword = query
        },
        focusPhone(val) {
            this.$nextTick(() => {
                this.onPhoneCodeChange(val);
                this.$refs.phoneInputRef.focus();
                this.$refs.registerForm.clearValidate('phone');
            })
        },
        async initRegion(){
            const res = await fetch('https://api.country.is/')
            const data = await res.json()      
            const regionCode = data.country;
            const findPhoneCode = countryPhoneCodes.find(x => x.code === regionCode);
            this.registerForm.phoneCode = findPhoneCode.dial_code;
            this.registerForm.region = regionCode;
            this.$nextTick(() => {
                this.$refs.registerForm.clearValidate('phone');
            })
        },
        onPhoneCodeChange(value) {
            const findPhoneCode = countryPhoneCodes.find(x => x.code === value);
            this.registerForm.region = findPhoneCode.code;
        },
        combinePhone(phoneCode, phoneNumber) {
            if (!phoneCode || !phoneNumber) return ''

            // remove spaces, -, ()
            const cleanCode = phoneCode.replace(/[^\d+]/g, '')
            const cleanPhone = phoneNumber.replace(/\D/g, '')

            // remove leading 0
            const normalizedPhone = cleanPhone.replace(/^0+/, '')

            return `${cleanCode}${normalizedPhone}`
        },
        addScript(scriptString) {
            //add gtag
            let gTagMngScript = document.createElement("script");
            gTagMngScript.type = `text/javascript`;
            gTagMngScript.text = scriptString;
            document.head.appendChild(gTagMngScript);
        },
        // Submit form register
        submitForm(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.isLoading = true;
                    let information = this.getInformationClient();
                    this.registerForm.phone = this.combinePhone(this.registerForm.phoneCode, this.registerForm.phone);
                    this.registerForm.deviceInformation = JSON.stringify(this.getInformationClient());
                    this.registerForm.browserDetails = information.browserDetails;
                    this.registerForm.timeZone = information.timeZone;
                    this.registerForm.resolutionDevice = information.resolutionDevice;

                    let languageBrowse = navigator.language || navigator.userLanguage;
                    this.registerForm.language = languageBrowse;
                    this.registerForm.affiliateId = this.$route.query.affiliateId;
                    this.registerForm.userName = this.registerForm.userName.toLowerCase();

                    authApi
                        .registerUser(this.registerForm)
                        .then(res => {
                            setTimeout(() => {
                                try {
                                    this.isLoading = false;
                                    switch (res.errorCode) {
                                        case GPURENTAL_STATUS_CODE.Register_Success:
                                            this.openNewBackgroundTab();
                                            this.postRegisterSuccess();
                                            break;
                                        default:
                                            this.resetRecaptcha();
                                            this.$store.dispatch("common/showUnkownError", res, "Register failed ...");
                                            break;
                                    }
                                } catch (error) {
                                    this.resetRecaptcha();
                                    this.$store.dispatch("common/showUnkownError", error, "Register failed ...");
                                }
                            }, 1000);
                        })
                        .catch(error => {
                            setTimeout(() => {
                                try {
                                    this.isLoading = false;
                                    console.error("Register error:", error);
                                    if (error.name === 'Error') {
                                        this.resetRecaptcha();
                                        this.$store.dispatch("common/showCommonError", error);
                                    } else {
                                        switch (error.errorCode) {
                                            case GPURENTAL_STATUS_CODE.Register_UsernameExist:
                                                commonActionHandle.showCustomWarning(
                                                    "Register failed ...",
                                                    'The username already exist. If you forgot password please reset password before login!'
                                                );
                                                break;
                                            case GPURENTAL_STATUS_CODE.Register_EmailExist:
                                                commonActionHandle.showCustomWarning(
                                                    "Register failed ...",
                                                    'The email address already exist. If you forgot password please reset password before login!'
                                                );
                                                break;
                                            case GPURENTAL_STATUS_CODE.Customize_Error:
                                                commonActionHandle.showCustomWarning(
                                                    "Register failed ...",
                                                    error.message || 'An error occurred during registration. Please try again later or contact support.'
                                                );
                                                break;
                                            default:
                                                this.$store.dispatch("common/showUnkownError", error, "Register failed ...");
                                                break;
                                        }
                                    }
                                } catch (error) {
                                    this.$store.dispatch("common/showUnkownError", error, "Register failed ...");
                                }
                            }, 1000);
                            this.resetRecaptcha();
                        });
                } else {
                    this.isLoading = false;
                    return false;
                }
            });
        },

        openNewBackgroundTab() {
            var a = document.createElement("a");
            switch (this.registerForm.nationality) {
                case 'irendering.net':
                    a.href = "https://irendering.net/thankyou-promotion/";
                    break;
                case 'irenderFarm':
                    a.href = "https://irenderfarm.net/thank-you/";
                    break;
                default:
                    a.href = "https://irendering.net/thankyou-promotion/";
                    break;
            }
            var evt = document.createEvent("MouseEvents");
            //the tenth parameter of initMouseEvent sets ctrl key
            evt.initMouseEvent("click", true, true, window, 0, 0, 0, 0, 0,
                true, false, false, false, 0, null);
            a.dispatchEvent(evt);
        },

        // Post register success
        postRegisterSuccess() {
            this.openComponentView('Login');
        },

        verifyRecaptcha(response) {
            //console.log("verifyRecaptcha", response);
            this.$set(this.registerForm, "recaptchaToken", response);
        },
        expiredRecaptcha() {
            //console.log("expiredRecaptcha");            
            if (this.enabledRecaptcha) {
                this.$set(this.registerForm, "recaptchaToken", "");
                if (this.$refs.recaptchaComp) this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },
        renderRecaptcha(id) {
            //console.log("renderRecaptcha", id);
        },
        errorRecaptcha() {
            //console.log("errorRecaptcha");
        },
        resetRecaptcha() {
            if (this.enabledRecaptcha) {
                this.$set(this.registerForm, "recaptchaToken", "");
                this.$refs.recaptchaComp.reset();
                this.enabledRecaptcha = false;
                this.enabledRecaptcha = process.env.VUE_APP_ENABLED_RECAPTCHA;
            }
        },
        // Open component view
        openComponentView(componentName) {
            this.$emit("openComponentView", componentName);
        }
    }
};